import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Database, BarChart, Globe, Shield } from 'lucide-react'

const ERPSolutions = () => {
  const features = [
    {
      icon: <Database className="w-6 h-6" data-component-path="client/src/pages/services/ERPSolutions.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/ERPSolutions.jsx:7:12" />,
      title: 'Unified Data',
      description: 'Single source of truth for all operations'
    },
    {
      icon: <BarChart className="w-6 h-6" data-component-path="client/src/pages/services/ERPSolutions.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/ERPSolutions.jsx:13:12" />,
      title: 'Real-Time Reporting',
      description: 'Instant insights across all departments'
    },
    {
      icon: <Globe className="w-6 h-6" data-component-path="client/src/pages/services/ERPSolutions.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/ERPSolutions.jsx:19:12" />,
      title: 'Multi-Location',
      description: 'Manage global operations from one platform'
    },
    {
      icon: <Shield className="w-6 h-6" data-component-path="client/src/pages/services/ERPSolutions.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/ERPSolutions.jsx:25:12" />,
      title: 'Compliance Ready',
      description: 'Built-in regulatory compliance features'
    },
  ]

  return (
    <ServiceTemplate
      title="ERP Solutions"
      subtitle="Comprehensive enterprise resource planning for operational excellence"
      description="Unify your business operations with powerful ERP systems that provide real-time visibility, streamline processes, and drive efficiency across all departments. From finance to supply chain, manage everything in one integrated platform."
      features={features}
      heroImage="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default ERPSolutions